import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { SIDE_PADDING } from "../../app/theme/muiTheme";

const useStyles = makeStyles((theme) => ({
  root: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 5,
    paddingBottom: "2%",
    borderColor: theme.palette.secondary.light,
    overflow: "hidden",
  },
  datetxt: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
  },
  desctxt: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
  },
  image: {
    width: "100%",
  },
}));

const NewsCard = (props) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      md={6}
      style={{
        padding: "2%",
      }}
    >
      <div className={classes.root}>
        <img
          alt="news"
          src={_.get(props, ["data", "thumbnail"]) || "/images/news.svg"}
          className={classes.image}
        />
        <br />
        <br />
        <Typography className={classes.datetxt}>
          {moment(_.get(props, ["data", "updatedAt"])).format("DD/MM/YYYY")}
        </Typography>
        <br />
        <Typography className={classes.desctxt}>
          {_.get(props, ["data", "title"])}
        </Typography>
        <div style={{ paddingLeft: SIDE_PADDING }}>
          <Button
            onClick={() => {
              window.open(_.get(props, ["data", "url"]), "_blank");
            }}
          >
            Read More ->
          </Button>
        </div>
      </div>
    </Grid>
  );
};

export default NewsCard;
